import { requestJson } from "./apiClient";

export async function listDataSourceSchedules() {
  return requestJson("/api/admin/data-source-schedules");
}

export async function updateDataSourceSchedule(domain, sourceKey, payload) {
  const response = await requestJson(
    `/api/admin/data-source-schedules/${encodeURIComponent(domain)}/${encodeURIComponent(sourceKey)}`,
    {
      method: "PATCH",
      body: JSON.stringify(payload),
    }
  );
  return response.schedule || response;
}
